import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../../assets/css/timeTable.css';
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import Loader from '../../Shared/Loader/Loader';
import CommonConfig from '../../../utils/constant';

const EditClassTimeTable = (props) => {
    const { catchResponse } = useCatchResponse();
    const [subjectList, setSubjectList] = useState([]);
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [periodsList, setPeriodsList] = useState([]);
    const [editTableData, setEditTableData] = useState([]);
    const [originalEditTableData, setOriginalEditTableData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        GetSubjectList(loginData?._id);
        GetTimeTableData(props?.location?.state?.ClassId);
    }, []);

    const GetSubjectList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getSubjectList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let subjectData = res?.data
                        ?.filter(y => y?.Classes?.split(',')?.includes(props?.location?.state?.ClassId))
                        ?.map(x => ({
                            TeachersList: x?.TeachersList,
                            label: x?.SubjectName,
                            value: x?._id
                        }));
                    setSubjectList([...subjectData]);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTimeTableData = async (classId) => {
        try {
            let data = {
                ClassId: classId,
            }
            Loader.show();
            const response = await api.post(APIConstant.path.GetTimeTableByClass, data);
            if (response?.success && response?.data.length > 0) {
                let periodTempData = response?.data[0]?.Periods?.map((x, idx) => {
                    return { Time: x?.Time, isBreak: x?.SubjectId === 'Break' ? true : false }
                });
                const periodData = periodTempData?.length && periodTempData?.map((period) => {
                    const times = period?.Time?.replace('Break - ', '')?.split(' - ');
                    const [from, to] = times?.map((time) => {
                        const match = time?.match(/(\d+):(\d+)\s(AM|PM)/);

                        if (!match) return null;

                        const [hours, minutes, ampm] = match;
                        const date = new Date();
                        date.setHours(ampm === 'PM' && hours !== '12' ? parseInt(hours, 10) + 12 : parseInt(hours, 10));
                        date.setMinutes(parseInt(minutes, 10));
                        return date;
                    });

                    return {
                        Time: period?.Time,
                        isEdit: false,
                        isBreak: period?.isBreak,
                        FromTime: from,
                        ToTime: to,
                    };
                });
                setPeriodsList(periodData);
                let timeTableEditData = response?.data?.map(row => {
                    const formattedRow = { Day: row?.Day, id: row?.id };
                    row?.Periods.forEach((period, index) => {
                        formattedRow[`Period${index + 1}`] = period?.SubjectId;
                        formattedRow[`Teacher${index + 1}`] = period?.TeacherId;
                    });
                    return formattedRow;
                });
                const EditsortedData = timeTableEditData.sort((a, b) => {
                    return days.indexOf(a?.Day) - days.indexOf(b?.Day);
                });

                setEditTableData(EditsortedData);
                setOriginalEditTableData(EditsortedData);
            } else {
                setPeriodsList([]);
                setEditTableData([]);
                setOriginalEditTableData([]);
                Toast.error({ message: response?.message });
            }
            Loader.hide();
        } catch (error) {
            Loader.hide();
            console.error("Error fetching timetable:", error);
            catchResponse(error);
        }
    };

    const handleDropdownChange = (e, rowData, period) => {
        const updatedData = editTableData.map(row => {
            if (row?.Day === rowData?.Day) {
                return { ...row, [period]: e.value };
            }
            return row;
        });

        const sortedData = updatedData.sort((a, b) => {
            return days.indexOf(a?.Day) - days.indexOf(b?.Day);
        });

        setEditTableData(sortedData);
    };

    const handleTeacherDropdownChange = (e, rowData, period) => {
        const updatedData = editTableData.map(row => {
            if (row?.Day === rowData?.Day) {
                return { ...row, [period]: e.value };
            }
            return row;
        });

        const sortedData = updatedData.sort((a, b) => {
            return days.indexOf(a?.Day) - days.indexOf(b?.Day);
        });

        setEditTableData(sortedData);
    };

    const saveTimeTable = async () => {
        try {
            const requestData = editTableData.map(row => ({
                id: row?.Id,
                // ClassId: props?.location?.state?.ClassId,
                Day: row?.Day,
                Periods: periodsList?.map((period, index) => ({
                    ClassId: props?.location?.state?.ClassId,
                    Time: period?.Time,
                    SubjectId: period?.Time?.includes('Break') ? 'Break' : row[`Period${index + 1}`],
                    TeacherId: period?.Time?.includes('Break') ? 'Break' : row[`Teacher${index + 1}`],
                }))
            }));
            const response = await api.post(APIConstant.path.AddUpdateTimeTableEntry, requestData);
            if (response.success) {
                Toast.success({ message: response.message });
                navigate(-1);
            } else {
                Toast.error({ message: "Failed to save timetable" });
            }
        } catch (error) {
            console.error("Error saving timetable:", error);
            catchResponse(error);
        }
    };

    const handleEditColumnName = (type, rowIndex, value) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) =>
                index === rowIndex ? { ...item, [type]: new Date(value) } : item
            )
        );
    };

    const handleDeleteColumn = (index) => {
        const updatedPeriodsList = periodsList?.filter((_, i) => i !== index);
        const updatedTableData = editTableData.map((row) => {
            const updatedRow = { ...row };
            delete updatedRow[`Period${index + 1}`];
            return updatedRow;
        });
        setPeriodsList(updatedPeriodsList);
        setEditTableData(updatedTableData);
    };

    const handleToggleEdit = (rowIndex) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) => {
                if (index === rowIndex) {
                    let formattedTime = item?.Time;
                    if (item?.isEdit && item?.FromTime && item?.ToTime) {
                        const formatTime = (time) => {
                            const date = new Date(time);
                            const hours = date.getHours();
                            const minutes = date.getMinutes();
                            const ampm = hours >= 12 ? 'PM' : 'AM';
                            const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
                            const formattedMinutes = minutes.toString().padStart(2, '0');
                            return `${formattedHours}:${formattedMinutes} ${ampm}`;
                        };
                        formattedTime = `${formatTime(item.FromTime)} - ${formatTime(item.ToTime)}`;
                    }

                    return {
                        ...item,
                        isEdit: !item?.isEdit,
                        Time: formattedTime,
                    };
                }
                return {
                    ...item,
                    isEdit: false,
                };
            })
        );
    };

    const handleToggleBreak = (rowIndex, value) => {
        setPeriodsList((prevItems) =>
            prevItems.map((item, index) => {
                if (index === rowIndex) {
                    return {
                        ...item,
                        isBreak: value,
                    };
                }
                return {
                    ...item,
                };
            })
        );
        const updatedTableData = editTableData.map((row, rowIdx) => {
            const updatedRow = { ...row };
            if (value) {
                updatedRow[`Period${rowIndex + 1}`] = 'Break';
            } else {
                const originalRow = originalEditTableData?.[rowIdx];
                const originalValue = originalRow?.[`Period${rowIndex + 1}`];
                const originalTeacherValue = originalRow?.[`Teacher${rowIndex + 1}`];
                updatedRow[`Period${rowIndex + 1}`] = (originalValue === 'Break' ? '' : originalValue) ?? updatedRow[`Period${rowIndex + 1}`];
                updatedRow[`Teacher${rowIndex + 1}`] = (originalTeacherValue === 'Break' ? '' : originalTeacherValue) ?? updatedRow[`Teacher${rowIndex + 1}`];

            }
            return updatedRow;
        });
        setEditTableData(updatedTableData);
    };

    const handleAddColumn = () => {
        const newColumn = {
            Time: `New Column ${periodsList.length + 1}`,
            isEdit: true,
            isBreak: false
        };
        setPeriodsList([...periodsList, newColumn]);
        const updatedTableData = editTableData.map((row) => ({
            ...row,
            [`Period${periodsList.length + 1}`]: '',
        }));
        setEditTableData(updatedTableData);
    };

    return (
        <div className="wayment-owner-dashboard">
            <div className="heading-area p-d-flex p-ai-center p-jc-between p-w-100">
                <div className="p-d-flex p-ai-baseline">
                    <i
                        className="pi pi-arrow-left"
                        style={{ cursor: 'pointer', marginRight: '1rem' }}
                        onClick={() => navigate('/time-table-configuration')}
                        title="Back"
                    ></i>
                    <h2>Edit Class Time Table</h2>
                </div>
                <div>
                    <Button
                        className="e-sction-btn p-my-2"
                        icon="pi pi-plus"
                        onClick={handleAddColumn}
                    />
                </div>
            </div>
            <div className='e-class-time-table'>
                <div>
                    <DataTable
                        value={editTableData}
                        responsiveLayout="scroll"
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column field="Day" header="Days/Periods" />
                        {periodsList?.map((period, index) => (
                            <Column
                                key={index}
                                field={`Period${index + 1}`}
                                header={
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {period?.isEdit ? (
                                            <>
                                                <Calendar
                                                    value={period?.FromTime}
                                                    onChange={(e) => handleEditColumnName('FromTime', index, e.value)}
                                                    hourFormat="12"
                                                    showTime
                                                    showSeconds={false}
                                                    timeOnly
                                                    className='time-table-input'
                                                />
                                                <Calendar
                                                    className='p-ml-2 time-table-input'
                                                    value={period?.ToTime}
                                                    onChange={(e) => handleEditColumnName('ToTime', index, e.target.value)}
                                                    hourFormat="12"
                                                    showTime
                                                    showSeconds={false}
                                                    timeOnly
                                                />
                                            </>
                                        ) : (
                                            <div>{period?.Time}</div>
                                        )}
                                        <Button
                                            icon={period?.isEdit ? "pi pi-check" : "pi pi-pencil"}
                                            className={period?.isEdit ? "e-btn p-ml-2" : "p-button-text p-button-danger"}
                                            onClick={() => handleToggleEdit(index)}
                                        />
                                        <Button
                                            icon="pi pi-trash"
                                            className="p-button-text e-btn p-ml-2 p-button-danger"
                                            onClick={() => handleDeleteColumn(index)}
                                        />
                                        <Checkbox
                                            className='p-ml-2'
                                            inputId="randomCheckbox"
                                            checked={period?.isBreak}
                                            onChange={(e) => handleToggleBreak(index, e.checked)}
                                        />
                                        <label htmlFor="randomCheckbox" style={{ marginLeft: '8px' }}>Break</label>
                                    </div>
                                }
                                body={(rowData) =>
                                    rowData[`Period${index + 1}`] === 'Break' ? (
                                        rowData[`Period${index + 1}`]
                                    ) : (
                                        <div className="dropdown-container">
                                            <Dropdown
                                                value={rowData[`Period${index + 1}`]}
                                                options={subjectList}
                                                onChange={(e) =>
                                                    handleDropdownChange(e, rowData, `Period${index + 1}`)
                                                }
                                                placeholder="Select Subject"
                                                style={{ width: '100%' }}
                                                filter
                                                showClear
                                            />
                                            <Dropdown
                                                value={rowData[`Teacher${index + 1}`]}
                                                options={subjectList.filter(x => x?.value === rowData[`Period${index + 1}`] ?? '').length ? subjectList.filter(x => x?.value === rowData[`Period${index + 1}`] ?? '')[0]?.TeachersList : []}
                                                optionLabel='Name'
                                                optionValue='id'
                                                onChange={(e) => handleTeacherDropdownChange(e, rowData, `Teacher${index + 1}`)}
                                                placeholder="Select Teacher"
                                                className="dropdown"
                                                filter
                                                showClear
                                            />
                                        </div>
                                    )
                                }
                            />
                        ))}
                    </DataTable>
                </div>
                <div>
                    <Button
                        className="p-m-0 btn-text-action-primary p-m-1 color-white"
                        label="Update"
                        severity="secondary"
                        raised
                        onClick={(e) => saveTimeTable()}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditClassTimeTable;
